/** Where the account, orders and risk views register in the router (INC-0609). */
import type { Route } from "../../app/router.ts";
import type { ViewFactory } from "../../app/view.ts";
import { mountNotFound } from "../stubs.ts";
import { mountOrders } from "../orders/index.ts";
import { mountRisk } from "../risk/index.ts";
import { mountAccount } from "./index.ts";
import { mountManualFills } from "./manual-fills.ts";

/** Portfolio is the account and positions; `#/portfolio/risk` the risk controls; `#/portfolio/fills` the recorded fills (U040). */
export function resolvePortfolio(route: Route): ViewFactory {
  switch (route.sub) {
    case null:
      return mountAccount;
    case "risk":
      return mountRisk;
    case "fills":
      return (ctx) => mountManualFills(ctx);
    default:
      return mountNotFound;
  }
}

/** Orders is the order tree, the command lifecycle and the reconciliation differences. */
export function resolveOrders(): ViewFactory {
  return mountOrders;
}
